import React from "react";

const BendIcon = () => (
  <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
       viewBox="0 -200 700 700"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier"> <g> <path
      d="M9.677,63.081c-12.902,12.904-12.902,33.822,0,46.707c57.689,57.691,132.156,88.238,207.861,92.432l2.096-40.805 c0.465-9.129,3.74-17.58,8.887-24.707c-62.512-1.662-124.541-26.049-172.137-73.627C43.481,50.179,22.581,50.179,9.677,63.081z"></path>
      <path
        d="M460.878,109.789c12.904-12.885,12.904-33.803,0-46.707c-12.869-12.902-33.803-12.902-46.705,0 c-33.418,33.4-73.982,55.207-116.783,65.965l65.608,47.158C398.528,160.738,431.88,138.787,460.878,109.789z"></path>
      <path
        d="M486.362,305.552L273.956,152.884c-2.34-1.678-5.1-2.549-7.873-2.549c-1.986,0-3.984,0.453-5.836,1.34 c-4.455,2.127-7.371,6.531-7.629,11.465l-13.471,261.262c-0.271,5.436,2.742,10.498,7.646,12.854 c1.854,0.887,3.852,1.322,5.824,1.322c3.256,0,6.467-1.178,8.996-3.436l94.348-84.318l124.771-21.016 c5.371-0.902,9.674-4.949,10.898-10.24C492.862,314.261,490.794,308.73,486.362,305.552z"></path> </g> </g></svg>);

export default BendIcon
